import { RESET_STATE } from 'store/global/actions';

import {
  ADD_ADJUSTMENT_CRITERIA,
  EDIT_ADJUSTMENT_CRITERIA,
  GET_ADJUSTMENT_CRITERIA,
} from '../actions';

const initialState = {};

const adjustmentCriteriaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ADJUSTMENT_CRITERIA:
      return payload.criteria || initialState;

    case ADD_ADJUSTMENT_CRITERIA:
    case EDIT_ADJUSTMENT_CRITERIA:
      return { ...state, [payload.criteriaId]: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default adjustmentCriteriaReducer;
